import GenericModel from '../generic-model';

export class SignCompany extends GenericModel {
  name: string;
  regularName: string;
}
